import { useState } from "react";
import { Plus, List } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const DEFAULT_AREAS = ["A1", "A2", "A3", "A4", "B1", "B3"];

/** Pilih area dari daftar (bawaan + yang sudah dipakai) atau ketik area baru secara manual. */
export function AreaPicker({ value, onChange, extra = [], testid = "area-picker" }) {
  const [manual, setManual] = useState(false);
  const options = [...new Set([...DEFAULT_AREAS, ...extra, value].filter(Boolean))].sort();
  if (manual) {
    return (
      <div className="flex items-center gap-2">
        <Input autoFocus value={value || ""} onChange={(e) => onChange(e.target.value.toUpperCase().replace(/\s+/g, ""))} placeholder="Ketik area baru, mis. C1" maxLength={8} className="font-mono uppercase" data-testid={`${testid}-input`} />
        <button type="button" onClick={() => setManual(false)} className="inline-flex shrink-0 items-center gap-1 rounded border border-slate-700 px-2 py-2 text-xs text-slate-300 hover:bg-slate-800" title="Pilih dari daftar" data-testid={`${testid}-list`}><List className="h-3.5 w-3.5" />Daftar</button>
      </div>
    );
  }
  return (
    <Select value={value || ""} onValueChange={(v) => { if (v === "__new") { onChange(""); setManual(true); } else onChange(v); }}>
      <SelectTrigger className="border-slate-800 bg-slate-900/70" data-testid={`${testid}-select`}><SelectValue placeholder="Pilih area" /></SelectTrigger>
      <SelectContent className="bg-[#0D1524] border-slate-800 max-h-64 z-[100]">
        {options.map((a) => <SelectItem key={a} value={a}>{a}</SelectItem>)}
        <SelectItem value="__new" data-testid={`${testid}-new`}><span className="inline-flex items-center gap-1 text-sky-300"><Plus className="h-3 w-3" />Tambah area baru secara manual…</span></SelectItem>
      </SelectContent>
    </Select>
  );
}
